import clsx from "clsx"

import { linkResolver } from "~/api/prismic/linkResolver"
import type { Article, Category } from "~/api/prismic/types"
import { PublishedItemPreview } from "~/components/PublishedItemPreview"
import { SEO } from "~/components/SEO"
import { getSummaryText } from "~/utils/articles/getSummaryText"
import * as RichText from "~/utils/prismic/richText"
import {
  getClassesByColorScheme,
  getRelatedColorSchemeId,
} from "~/utils/style/colorSchemes"

// FIXME: Decouple from CMS data structure where possible
export type CategoryPageProps = {
  category: Category
  articles: Article[]
}

export const CategoryPage: React.FC<CategoryPageProps> = ({
  category,
  articles,
}) => {
  const { name, color_scheme } = category.data

  const categoryClasses = getClassesByColorScheme({ colorScheme: color_scheme })
  const colorSchemeId = getRelatedColorSchemeId(color_scheme)

  return (
    <>
      <SEO pageTitle={name} path={linkResolver(category)} />
      <section className={clsx("mx-auto max-w-screen-lg md:p-4")}>
        <div
          className={clsx(
            categoryClasses.bg,
            categoryClasses.text,
            "py-6 px-4 md:p-8",
          )}
        >
          <h1 className={clsx("text-2xl md:text-4xl")}>{name}</h1>
        </div>
        <ul className="mx-auto mb-8 grid max-w-screen-lg gap-4 sm:grid-cols-2 md:mt-8 md:gap-12">
          {articles.map((article) => {
            return (
              <li key={article.id}>
                <PublishedItemPreview
                  href={linkResolver(article)}
                  title={RichText.asText(article.data.title)}
                  description={getSummaryText(article)}
                  image={article.data.banner_image}
                  date={article.first_publication_date}
                  colorScheme={colorSchemeId}
                />
              </li>
            )
          })}
        </ul>
      </section>
    </>
  )
}
